import React from 'react';

import classNames from 'classnames';

import './styles.css';

const Label = ({className, children, htmlFor}: any) => (
  <label htmlFor={htmlFor} className={classNames('Label', className)}>
    {children}
  </label>
);

export default Label;
